<template>
  <div>
    <div class="smallbox">
      <div class="smalltitle">
        {{
          interestRecommend.jobDirection
            ? interestRecommend.jobDirection
            : "对应专业方向"
        }}
      </div>
      <pre class="smalltext" v-html="interestRecommend.jobDirectionContent
            ? interestRecommend.jobDirectionContent
            : ''">
      </pre>
    </div>
    <div class="line"></div>
    <div class="smallbox">
      <div class="smalltitle">
        {{
          interestRecommend.proDirection
            ? interestRecommend.proDirection
            : "对应职业方向"
        }}
      </div>
       <pre class="smalltext" v-html="interestRecommend.proDirectionContent
            ? interestRecommend.proDirectionContent
            : ''">
      </pre>
    </div>
     <div class="line"></div>
    <div class="smallboxlast">
      <div class="smalltitle">
        {{
          interestRecommend.proCautious
            ? interestRecommend.proCautious
            : "慎选专业"
        }}
      </div>
      <pre class="smalltext" v-html="interestRecommend.proCautiousContent
            ? interestRecommend.proCautiousContent
            : ''">
      </pre>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    interestRecommend: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.smallbox{
  margin-top: 20px;
}
.smallboxlast {
  padding-bottom: 40px;
}
.smalltitle {
  display: inline-block;
  width: 200px;
  font-size: 14px;
  font-weight: 700;
  padding-right: 50px;
  text-align: right;
}
.smalltext {
  display: inline-block;
  width: 750px;
  font-size: 14px;
  vertical-align: top;
}
.line {
  border-bottom: 2px dashed rgba(0, 0, 0, 0.2);
  margin-bottom: 20px;
  margin-top: 20px;
}
</style>